import React, { FC } from 'react';
import { SkeletonProps, Skeleton } from '@beeline.com/bp-design-system';

interface Props {
  loading?: boolean;
  skeletonProps?: SkeletonProps;
}

const DEFAULT_SKELETON_PROPS: SkeletonProps = {
  randomWidthInPercentage: true
};

export const LoadingContent: FC<React.PropsWithChildren<Props>> = ({ loading, children, skeletonProps }) => {
  const skeleton: SkeletonProps = skeletonProps ?? DEFAULT_SKELETON_PROPS;
  if (loading) {
    return <Skeleton {...{ ...DEFAULT_SKELETON_PROPS, ...skeleton }} />;
  }
  return <>{children}</>;
};
